import React, { useState } from 'react';

// Hooks
import useUrlContains from '@src/hooks/useUrlContains';

// Comps
import AccountForm from '@project-stories/ecommerce/Account/AccountForm/AccountForm';
import AccountFormHeader from '@project-stories/ecommerce/Account/AccountFormHeader/AccountFormHeader';
import {Link} from '@arctheme-components/elements/Link/Link';

type Props = {
    section: any;
    signUpFields: any;
    headerColorSchema?: string;
    blockSettings?: any;
};

export const Default = ({ section, signUpFields, headerColorSchema, blockSettings }: Props) => {
    const {
        // Typography
        title_type,
        title_type_mobile,
        body_type,
        body_type_mobile,
    } = section;

    // Extract block settings
    const loginForm = blockSettings?.loginForm || {};
    const registerCta = blockSettings?.registerCta || {};

    // States
    const [showCustomFields, setShowCustomFields] = useState(true);

    // Hooks
    const isRegisterPage: boolean = useUrlContains('register');

    // Form header settings
    const headerTitleType = `${title_type_mobile} ${title_type}-lg`;
    const headerTaglineType = `${body_type_mobile} ${body_type}-lg`;

    return (
        <>
            <div className='md:sticky top-[calc(var(--header-height)+1rem)]'>
                <AccountFormHeader
                    title={isRegisterPage ? registerCta.title_register_cta : loginForm.title_login}
                    titleType={headerTitleType}
                    tagline={isRegisterPage ? registerCta.tagline_register_cta : loginForm.tagline_login}
                    taglineType={headerTaglineType}
                    colorSchema={loginForm.header_color_schema || headerColorSchema}
                />

                <AccountForm
                    section={{
                        ...section,
                        ...(isRegisterPage ? registerCta : loginForm)
                    }}
                    isRegister={isRegisterPage}
                    showCustomFields={showCustomFields}
                    signUpFields={signUpFields}
                />
            </div>
        </>
    );
};

export default Default;